// Extract the return type from a Promise-returning function
type ExtractPromiseReturnType<T> = T extends () => Promise<infer R> ? R : never;

export const asyncActionUntillResult = async <T extends () => Promise<unknown>>(
  action: T,
  until: (result: ExtractPromiseReturnType<T>) => boolean,
  interval: number,
  timeout: number,
): Promise<ExtractPromiseReturnType<T>> => {
  const startTime = Date.now();

  while (Date.now() - startTime < timeout) {
    try {
      const result = await action();

      if (until(result as ExtractPromiseReturnType<T>)) {
        return result as ExtractPromiseReturnType<T>;
      }

      await new Promise((resolve) => setTimeout(resolve, interval));
    } catch (error) {
      console.warn('Error during polling:', error);

      await new Promise((resolve) => setTimeout(resolve, interval));
    }
  }

  throw new Error(
    `asyncActionUntillResult: Timeout reached after ${timeout}ms`,
  );
};
